import { render } from "./DeliveryReceipt.vue?vue&type=template&id=bec3a202&scoped=true"
import script from "./DeliveryReceipt.vue?vue&type=script&lang=js"
export * from "./DeliveryReceipt.vue?vue&type=script&lang=js"

import "./DeliveryReceipt.vue?vue&type=style&index=0&id=bec3a202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec3a202"]])

export default __exports__